import { dataChevronDoubleDown } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronDoubleDown = /*#__PURE__*/createIcon(dataChevronDoubleDown)
export default IconChevronDoubleDown
